import React, { useMemo } from 'react'
import { EventGQL } from '../../../../Api/events/events.types'
import { BoxScoreInfoCon } from '../styles'
import { BoxScoreAction } from './BoxScoreAction'
import { checkSpecialWeek } from '../../../../Utils/EventHelpers/eventHelpers'

type ActionProps = {
  event: EventGQL
  date?: string
}

export const BoxScoreInfo: React.FC<React.PropsWithChildren<ActionProps>> = ({
  event,
  date,
}) => {
  const infoText = useMemo(() => {
    const specialWeekText = checkSpecialWeek([event])
    if (event?.seasonSegment === 'regular') {
      return `${event.location ?? ''}`
    }
    if (event?.seasonSegment === 'post') {
      if (!specialWeekText) return null
      return specialWeekText ? `${specialWeekText} • ${event.location ?? ''}` : `${event.location ?? ''}`
    }
    return event.location ?? ''
  }, [event])

  return (
    <BoxScoreInfoCon>
      <div className="weekCol">
        {infoText && <div className="week">{infoText}</div>}
        {date && <div className="dateBoxText">{date}</div>}
      </div>
      <BoxScoreAction event={event} buttonText="Watch" />
      <BoxScoreAction event={event} buttonText="Tickets" />
    </BoxScoreInfoCon>
  )
}
